/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { entity, enumeration } from '@gh/core-data';

import { JobStageListItemDto, JobStageListItemStatus } from './job-stage.dto';

export const JobStageListItemMapper = entity<JobStageListItemDto>({
  status: enumeration(JobStageListItemStatus),
});
